import React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import Toggle from "react-toggle";
import "react-toggle/style.css";
const sizing = {
  margin: { right: 5 },
  width: 300, // Adjust width as needed
  height: 280, // Adjust height as needed
  legend: { hidden: true },
};

export default ({
  selectedOtherInterval,
  setSelectedOtherInterval,
  wtnList,
  setwtnFields,
  wtnFields,
}) => {
  const currentYear = new Date().getFullYear();
  const futureYears = Array.from(
    { length: 5 },
    (_, index) => currentYear + index
  );

  const data = {
    daily: {
      uData:
        wtnList?.userData?.res_data.length > 0
          ? wtnList?.userData?.res_data
          : Array(31).fill(0),
      xLabels: Array.from({ length: 31 }, (_, index) => `Day ${index + 1}`),
    },
    weekly: {
      uData:
        wtnList?.userData?.res_data.length > 0
          ? wtnList?.userData?.res_data
          : Array(7).fill(0),
      xLabels: [
        "Week 1",
        "Week 2",
        "Week 3",
        "Week 4",
        "Week 5",
        "Week 6",
        "Week 7",
      ],
    },
    monthly: {
      uData:
        wtnList?.userData?.res_data.length > 0
          ? wtnList?.userData?.res_data
          : Array(12).fill(0),
      xLabels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yearly: {
      uData:
        wtnList?.userData?.res_data?.length > 0
          ? wtnList?.userData?.res_data
          : Array(futureYears.length).fill(0),
      xLabels: futureYears.length > 0 ? futureYears.map(String) : [],
    },
  };
  //for pie chart
  function convertData(originalData) {
    let convertedData = {
      data: [],
    };

    originalData[selectedOtherInterval]?.uData?.forEach((value, index) => {
      convertedData.data.push({
        value: value,
        label: `${wtnFields?.type === "1" ? "Range" : "Age"} ${
          originalData[selectedOtherInterval]?.xLabels[index]
        }`,
        color: "#02B2AF",
      });
    });
    return convertedData;
  }
  const convertedData = convertData(data);

  const handleSelectOption = (e) => {
    const { name, value } = e.target;
    setwtnFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="">
                    <b>
                      Match played by{" "}
                      {wtnFields?.type === "1" ? "WTN ranges" : "palyer age"}
                    </b>
                  </h4>
                  <div className="form-group col-md-3">
                    <label htmlFor="gender">Select type</label>
                    <div className="col-md-12">
                      <select
                        className="form-select"
                        name="type"
                        onChange={(e) => handleSelectOption(e)}
                      >
                        <option value="" selected disabled>
                          Select{" "}
                        </option>
                        <option
                          value="1"
                          selected={wtnFields?.type === "1" ? "selected" : ""}
                        >
                          WTN Range{" "}
                        </option>
                        <option
                          value="0"
                          selected={wtnFields?.type === "0" ? "selected" : ""}
                        >
                          Player Age Range{" "}
                        </option>
                      </select>
                    </div>
                  </div>
                  {wtnFields?.type === "0" ? (
                    <div className="form-group col-md-3">
                      <label htmlFor="gender">Select player age range</label>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          name="wtn_range"
                          onChange={(e) => handleSelectOption(e)}
                        >
                          <option value="" selected disabled>
                            Select{" "}
                          </option>
                          <option
                            value="<10"
                            selected={
                              wtnFields?.wtn_range === "<10>" ? "selected" : ""
                            }
                          >
                            less than 10{" "}
                          </option>
                          <option
                            value="12-14"
                            selected={
                              wtnFields?.wtn_range === "12-14" ? "selected" : ""
                            }
                          >
                            12-14{" "}
                          </option>
                          <option
                            value="15-16"
                            selected={
                              wtnFields?.wtn_range === "15-16" ? "selected" : ""
                            }
                          >
                            15-16{" "}
                          </option>
                          <option
                            value="17-18"
                            selected={
                              wtnFields?.wtn_range === "17-18" ? "selected" : ""
                            }
                          >
                            17-18{" "}
                          </option>
                          <option
                            value="19-25"
                            selected={
                              wtnFields?.wtn_range === "19-25" ? "selected" : ""
                            }
                          >
                            19-25{" "}
                          </option>
                          <option
                            value="25-30"
                            selected={
                              wtnFields?.wtn_range === "25-30" ? "selected" : ""
                            }
                          >
                            25-30{" "}
                          </option>
                          <option
                            value="30-35"
                            selected={
                              wtnFields?.wtn_range === "30-35" ? "selected" : ""
                            }
                          >
                            30-35{" "}
                          </option>
                          <option
                            value="36-40"
                            selected={
                              wtnFields?.wtn_range === "36-40" ? "selected" : ""
                            }
                          >
                            36-40{" "}
                          </option>
                          <option
                            value=">40"
                            selected={
                              wtnFields?.wtn_range === ">40" ? "selected" : ""
                            }
                          >
                            greater than 40{" "}
                          </option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    <div className="form-group col-md-3">
                      <label htmlFor="gender">Select WTN Range</label>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          name="wtn_range"
                          onChange={(e) => handleSelectOption(e)}
                        >
                          <option value="" selected disabled>
                            Select{" "}
                          </option>
                          <option
                            value="<10"
                            selected={
                              wtnFields?.wtn_range === "<10" ? "selected" : ""
                            }
                          >
                            less than 10{" "}
                          </option>
                          <option
                            value="10-15"
                            selected={
                              wtnFields?.wtn_range === "10-15" ? "selected" : ""
                            }
                          >
                            10-15{" "}
                          </option>
                          <option
                            value="16-20"
                            selected={
                              wtnFields?.wtn_range === "16-20" ? "selected" : ""
                            }
                          >
                            16-20{" "}
                          </option>
                          <option
                            value="21-25"
                            selected={
                              wtnFields?.wtn_range === "21-25" ? "selected" : ""
                            }
                          >
                            21-25{" "}
                          </option>
                          <option
                            value="26-30"
                            selected={
                              wtnFields?.wtn_range === "26-30" ? "selected" : ""
                            }
                          >
                            26-30{" "}
                          </option>
                          <option
                            value=">30"
                            selected={
                              wtnFields?.wtn_range === ">30" ? "selected" : ""
                            }
                          >
                            greater than 30{" "}
                          </option>
                        </select>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <BarChart
                    series={[
                      {
                        data: data[selectedOtherInterval]?.uData,
                        label: `${
                          wtnFields?.type === "1" ? "WTN Range" : "Player Age"
                        }`,
                        color: "#02B2AF",
                      },
                    ]}
                    xAxis={[
                      {
                        data: data[selectedOtherInterval].xLabels,
                        scaleType: "band",
                      },
                    ]}
                    // width={560}
                    height={300}
                  />
                </div>
                <PieChart
                  series={[
                    {
                      arcLabel: (item) => `${item.label} (${item.value})`,
                      arcLabelMinAngle: 45,
                      data: convertedData?.data,
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fill: "white",
                      fontSize: 10,
                    },
                  }}
                  {...sizing}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
